import RulePeformanceReportView from './RulePerformanceReportView';

export default RulePeformanceReportView;
